import './divider.scss'

export default (props) => <div className={`divider horizontal ${props.className} `} style={props.style}>
           {props.label && <div className="label">{props.label}</div>} 
</div>